import template from './teamRequestModalApprove.html';
import controller from './teamRequestModalApprove.controller';
import './teamRequestModalApprove.scss';

let teamRequestModalApproveComponent = {
  restrict: 'E',
  bindings: {
    modalId: '@',
    request: '<',
    showSuccess: '<',
    error: '<',
    onAccept: '&',
    delegation : '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default teamRequestModalApproveComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestModalApprove/teamRequestModalApprove.component.js